import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import CompanyModuleTypes from '@/store/modules/middleGround/my/company/interface';

const companyModule: Module<CompanyModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        listCompanyArea(context) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/listCompanyArea", {}).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        getCompany(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/getCompany", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        updateCompany(context, params) {
            return new Promise((resolve, reject) => {
                tool.postJson("/personalCenter/saveCompany", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        saveCompanyArea(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/saveCompanyArea", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        
    },
};

export default companyModule;